// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.giftshop-front-login{display:flex;flex:1;align-items:center;justify-content:center;flex-direction:column;padding:2rem}.giftshop-front-login-form{width:100%;max-width:400px;text-align:center}.giftshop-front-login-form-input{display:flex;gap:1rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
